export function OutreachMap() {
  return (
    <div className="w-full h-full bg-gray-100 rounded-lg flex items-center justify-center">
      <p className="text-gray-500">Map integration coming soon</p>
    </div>
  );
}